import { type TomBadge } from '@/ui/primitives/estilos';
import { AVISOS_VENCIMENTO_DIAS } from '@fiscoai/contracts';

const DIA_MS = 86_400_000;

export interface SituacaoCertificado {
  tipo: 'SEM' | 'EM_DIA' | 'VENCENDO' | 'VENCIDO';
  rotulo: string;
  tom: TomBadge;
  /** Dias até vencer (negativo = vencido há); nulo sem certificado. */
  dias: number | null;
}

/** Primeiro marco de aviso (60 dias): a partir dele o certificado está "vencendo". */
export const DIAS_VENCENDO = Math.max(...AVISOS_VENCIMENTO_DIAS);

/** Situação do certificado pela data de validade (mesma regra das pendências, spec 0005). */
export function situacaoCertificado(
  validoAte: string | null,
  agora: Date = new Date(),
): SituacaoCertificado {
  if (!validoAte) return { tipo: 'SEM', rotulo: 'Sem certificado', tom: 'neutro', dias: null };
  const dias = Math.ceil((Date.parse(validoAte) - agora.getTime()) / DIA_MS);
  if (dias <= 0) return { tipo: 'VENCIDO', rotulo: 'Vencido', tom: 'perigo', dias };
  if (dias <= DIAS_VENCENDO)
    return {
      tipo: 'VENCENDO',
      rotulo: dias === 1 ? 'Vence amanhã' : `Vence em ${String(dias)} dias`,
      tom: dias <= 15 ? 'perigo' : 'alerta',
      dias,
    };
  return { tipo: 'EM_DIA', rotulo: 'Em dia', tom: 'sucesso', dias };
}
